import React from "react";
import styles from "./Detail.module.scss";
// import CloseIcon from "../../../../../assets/images/pages/login/CloseButton.svg";
import CloseIcon from "../../../assets/images/pages/login/CloseButton.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";

interface OrderItem {
  address?: string;
  date?: string;
  payment_type?: string;
  delivery_amount?: string;
  total_amount?: string;
  status?: string;
  number?: string;
  gross_weight?: string;
  amount?: string;
  client_name?: string;
  client_surname?: string;
}
interface ModalProps {
  title: string;
  content: string | React.ReactNode;
  onClose: () => void;
  musteriId?: number;
  setShowModal: (value: boolean) => void;
  orderData?: OrderItem[];
}

const DetailModal: React.FC<ModalProps> = ({
  title,
  content,
  onClose,
  musteriId,
  setShowModal,
  orderData,
}) => {
  const { data } = useSelector((state: RootState) => state.translationData);

  return (
    <div className={styles.background} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className={styles.closeBtn}
          aria-label="Close modal"
        >
          <img src={CloseIcon} alt="" />
        </button>
        <h3>{title}</h3>
        <div className={styles.modalBody}>
          <div className={styles.tableContainer}>
            <table className={styles.Detail_history_list}>
              <thead>
                <tr>
                  <th>{data?.auth_common_tracking_code}</th>
                  <th>{data?.weight}</th>
                  <th>{data?.shipping_amount}</th>
                  <th>{data?.auth_courier_payment_type}</th>
                  <th>{data?.customer}</th>
                  <th>{data?.status}</th>
                </tr>
              </thead>
              <tbody>
                {orderData?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.number}</td>
                      <td>
                        {item.gross_weight}{" "}
                        <span style={{ marginLeft: "10px" }}>kg</span>
                      </td>
                      <td>
                        {item.amount}{" "}
                        <span style={{ marginLeft: "10px" }}>AZN</span>
                      </td>
                      <td>{item.payment_type}</td>
                      <td>
                        {item.client_name} {item.client_surname}
                      </td>
                      <td>
                        <div className={styles.status}>{item.status}</div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailModal;
